import { pdcsApiUpsellProvider, contactsApiUpsellProvider } from "../../../../lib/api/providers";
import dayjs from "dayjs";
import FileSaver from "file-saver";

export const getContactsFile = async (clientId, token) => {
  const contactsResponse = await contactsApiUpsellProvider.get(`/export/${clientId}`, {
    responseType: "arraybuffer",
    headers: {
      Authorization: token
    }
  });
  const contacts = contactsResponse.data;
  FileSaver.saveAs(
    new Blob([contacts], { type: "application/vnd.ms-excel" }),
    `${dayjs().format("DD-MM-YYYY")}-contacts-C${clientId}.xlsx`
  );
};

export const getPdcsFile = async (filters, token) => {
  const pdcsResponse = await pdcsApiUpsellProvider.post(
    "/export",
    { match: filters },
    {
      responseType: "arraybuffer",
      headers: {
        Authorization: token
      }
    }
  );
  const pdcs = pdcsResponse.data;
  FileSaver.saveAs(
    new Blob([pdcs], { type: "application/vnd.ms-excel" }),
    `${dayjs().format("DD-MM-YYYY")}-listePdcs.xlsx`
  );
};

export const getContactsFileByRetailer = async (retailerId, retailerLabel, token) => {
  const contactsResponse = await contactsApiUpsellProvider.get(`/export/byretailer/${retailerId}`, {
    responseType: "arraybuffer",
    headers: {
      Authorization: token
    }
  });
  const contacts = contactsResponse.data;
  FileSaver.saveAs(
    new Blob([contacts], { type: "application/vnd.ms-excel" }),
    `${dayjs().format("DD-MM-YYYY")}-contacts-enseigne-${retailerLabel}-(${retailerId}).xlsx`
  );
};



// WEBPACK FOOTER //
// src/containers/metier/pdcs/pdcs.utils/exportFiles.js